import { HTMLInputTypeAttribute } from 'react';
import styles from './styles.module.scss';

interface InputProps extends React.HTMLAttributes<HTMLInputElement> {
    type: HTMLInputTypeAttribute;
    value: React.ComponentState;
    wrapperClass?: string;
    inputWrapperClass?: string;
    disabled?: boolean;
}

export const Input = ({
    type,
    value,
    wrapperClass,
    inputWrapperClass,
    disabled = false,
    ...rest
}: InputProps) => {
    return (
        <div className={`${wrapperClass ?? ''} ${styles.wrapper}`}>
            <input
                type={type}
                value={value}
                className={`${inputWrapperClass ?? ''} ${styles.input} ${
                    !disabled && styles.customInteraction
                }`}
                disabled={disabled}
                {...rest}
            />
        </div>
    );
};
